import { DefaultGraph, IReshapeHandler, NodeSizeConstraintProvider } from "yfiles";
import { NODE_GROUP_MAX_SIZE, NODE_GROUP_MIN_SIZE } from "../../constants";
import NonOverlapReshapeHandler from "./nonOverlapReshapeHandler";
const groupSizeConstraintProvider = new NodeSizeConstraintProvider(NODE_GROUP_MIN_SIZE, NODE_GROUP_MAX_SIZE, null);
let reshapeHandlerDecoratorFactory = null;
const buildIsGroupPredicate = (graphComponentRef) => (node) => { var _a; return Boolean((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph.isGroupNode(node)); };
const buildFactory = (graphComponentRef) => (node) => {
    if (!buildIsGroupPredicate(graphComponentRef)(node))
        return null;
    const defaultReshapeHandler = DefaultGraph.DEFAULT_NODE_LOOKUP.contextLookup(node, IReshapeHandler.$class);
    return new NonOverlapReshapeHandler(graphComponentRef, node, defaultReshapeHandler);
};
export default (graphComponentRef, canEdit) => {
    if (!graphComponentRef.current)
        return;
    if (canEdit) {
        reshapeHandlerDecoratorFactory =
            graphComponentRef.current.graph.decorator.nodeDecorator.reshapeHandlerDecorator.setFactory(buildFactory(graphComponentRef));
        const { sizeConstraintProviderDecorator } = graphComponentRef.current.graph.decorator.nodeDecorator;
        sizeConstraintProviderDecorator.decorateNulls = true;
        sizeConstraintProviderDecorator.setImplementationWrapper(() => groupSizeConstraintProvider);
    }
    else {
        reshapeHandlerDecoratorFactory &&
            graphComponentRef.current.graph.decorator.nodeDecorator.remove(reshapeHandlerDecoratorFactory);
    }
    const groupPredicate = buildIsGroupPredicate(graphComponentRef);
    graphComponentRef.current.selection.selectedNodes
        .filter(groupPredicate)
        .toArray()
        .forEach(node => {
        var _a, _b;
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection.setSelected(node, false);
        (_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.selection.setSelected(node, true);
    });
};
